<template>
  <el-dialog
    top="50px"
    width="500px"
    :title="action.name"
    :visible="visible"
    :show-close="!callingAPI"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
    @close="$emit('close')"
  >
    <el-form
      ref="form"
      v-loading="loading"
      :model="form"
      :rules="rules"
      size="medium"
      label-position="top"
    >
      <p class="mt-0">
        {{ action.description }}
      </p>
      <el-row
        type="flex"
        align="start"
        class="flex-wrap"
        :gutter="12"
      >
        <el-col
          :lg="24"
          :span="24"
        >
          <el-form-item
            class="w-100"
            :label="`Danh sách ${config.extra.name} đã chọn`"
          >
            <el-select
              :value="selectedData.map((d) => d.id)"
              class="w-100"
              size="medium"
              multiple
              disabled
            >
              <el-option
                v-for="item in selectedData"
                :key="item.id"
                :label="item.extra.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          v-for="field in formFields"
          :key="field.key"
          :lg="24"
          :span="24"
        >
          <FormItem
            :form="form"
            :field="field"
            :disabled="callingAPI"
            :modules="config.extra.modules"
            size="medium"
          />
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        :disabled="callingAPI"
        size="medium"
        @click="$emit('close')"
      >
        Đóng
      </el-button>
      <el-button
        type="primary"
        :loading="callingAPI"
        size="medium"
        @click="handleConfirm"
        >Xác nhận</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import FormItem from "@/components/items/FormItem.vue";
import {
  arrayToObject,
  notification,
  convertPayloadData,
} from "@/utils/common";
import commonServices from "@/services/common";
import constants from "@/config/constants";

export default {
  name: "UpdateMultiplePopup",
  components: {
    FormItem
  },
  props: {
    config: Object,
    action: Object,
    visible: Boolean,
    selectedData: Array
  },
  data() {
    return {
      loading: false,
      form: {},
      callingAPI: false,
      fileType: constants.FIELD_TYPE,
    };
  },
  computed: {
    fields() {
      const result = this.config?.extra?.fields || [];
      return result;
    },
    formFields() {
      return this.fields
        .filter((f) => this.action.fields.includes(f.key))
        .sort((a, b) => a.order - b.order);
    },
    payloadData() {
      return this.selectedData.map((d) => {
        const data = {
          ...d,
          extra: {
            ...d.extra,
            ...this.form,
          },
        };
        return convertPayloadData(this.config.extra.key, data);
      })
    },
    rules() {
      const result = {};
      for (let i = 0; i < this.formFields.length; i++) {
        const field = this.formFields[i];
        const itemRules = [];
        if (field.form.required) {
          itemRules.push({
            required: true,
            message: `${field.name} là trường bắt buộc.`,
            trigger: ["blur", "change"],
          });
        }
        if (field.form.pattern) {
          const dataType = constants.DATA_TYPES.find(
            (t) => t.key === field.form.pattern
          );
          if (dataType) {
            itemRules.push({
              pattern: dataType.pattern,
              message: `${field.name} không hợp lệ.`,
              trigger: ["blur", "change"],
            });
          }
        }
        if (itemRules.length > 0) {
          result[field.key] = itemRules;
        }
      }
      return result;
    },
  },
  beforeMount() {
    this.loadFormData();
  },
  methods: {
    loadFormData() {
      this.form = arrayToObject(this.formFields);
    },
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.callingAPI = true;
          commonServices
            .updateMultiple(this.config.type, this.payloadData)
            .then(() => {
              this.$emit("close");
              this.$emit("reload");
              notification(this, "success", "", `${this.action.name} ${this.config.extra.name} thành công`);
              this.callingAPI = false;
            })
            .catch(() => {
              notification(this, "error", "", `${this.action.name} ${this.config.extra.name} thất bại`);
              this.callingAPI = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
